export default {"src":"/_next/static/media/ic_pause-no-fill.a7228012.svg","height":12,"width":10,"blurWidth":0,"blurHeight":0};